import { render, staticRenderFns } from "./ImageProcessor.vue?vue&type=template&id=dbaff9da&scoped=true&"
import script from "./ImageProcessor.vue?vue&type=script&lang=js&"
export * from "./ImageProcessor.vue?vue&type=script&lang=js&"
import style0 from "./ImageProcessor.vue?vue&type=style&index=0&id=dbaff9da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaff9da",
  null
  
)

export default component.exports